import { render, staticRenderFns } from "./Reposicao.vue?vue&type=template&id=2799af41&scoped=true&"
import script from "./Reposicao.vue?vue&type=script&lang=js&"
export * from "./Reposicao.vue?vue&type=script&lang=js&"
import style0 from "./Reposicao.vue?vue&type=style&index=0&id=2799af41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2799af41",
  null
  
)

export default component.exports